import React from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';

interface PayPalPaymentProps {
  planId: string;
  onSuccess: (data: any) => void;
  onError: (error: any) => void;
}

const PayPalPayment: React.FC<PayPalPaymentProps> = ({ planId, onSuccess, onError }) => {
  return (
    <PayPalScriptProvider options={{ clientId: 'AXMxbnMOVI7qVkoN3pwoAhRBxFTVS8AFNWAqTqihbrt_eU-mkkKuJ7bTgikk5R2OV17jFj5uj6unI4zG', vault: true, intent: 'subscription' }}>
      <PayPalButtons
        style={{ layout: 'vertical' }}
        fundingSource={undefined}
        createSubscription={(data, actions) => {
          return actions.subscription.create({
            plan_id: planId,
          });
        }}
        onApprove={(data, actions) => {
          onSuccess(data);
          return Promise.resolve();
        }}
        onError={onError}
      />
    </PayPalScriptProvider>
  );
};

export default PayPalPayment; 